import './style.scss';

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const galleryMasonry = () => {
  const elem = document.querySelector('.gallery__inner');

  if (!elem) return;

  imagesLoaded(elem, () => {
    const msnry = new Masonry(elem, {
      itemSelector: '.gallery__media',
      columnWidth: '.gallery__media',
      horizontalOrder: true,
      percentPosition: true,
      gutter: '.gallery__gutter-sizer',
    });
  });
}

galleryMasonry();